module.exports = "app-home{height:100%}#navbarDropdown{border:none;background:transparent}#navbarDropdown :focus{outline:0 !important}a:hover{cursor:pointer}\n"